import isBrowser from './isBrowser';

export const getPageHeaderHeight = () => {
  if (!isBrowser()) return 0;

  const header = document.querySelector('.Polaris-Box:has([class*="Polaris-Page-Header"])');
  return header?.clientHeight ?? 0;
};
